// extracted by mini-css-extract-plugin
export var chevron = "_jd-4";
export var chevronExpanded = "_jd-5";
export var row = "_jd-0";
export var rowBody = "_jd-6";
export var rowDescription = "_jd-7";
export var rowHeader = "_jd-1";
export var rowTitle = "_jd-2";
export var rowTitleComplete = "_jd-3";